var map = {
	"./home.png": 5865,
	"./proyecto-10.png": 9123,
	"./proyecto-11.png": 7210,
	"./proyecto-12.png": 4641,
	"./proyecto-13.png": 3512,
	"./proyecto-14.png": 5655,
	"./proyecto-7.png": 7037,
	"./proyecto-8.png": 3178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7958;